import React, { useState, useEffect, useRef } from "react";
import "./styles.css"

const Input = ({
	className = "w-100",
	type,
	id = null,
	name = null,
	placeholder,
	autocomplete = "off",
	onChange,
	autofocus = false,
	dataCy = "",
	initValue = "",
	disabled = false,
	...props
}) => {
	const [renderedClassList, setRenderedClassList] = useState(className)
	const [value, setValue] = useState(initValue);
	const focusClass = "focus-input";
	const hasValueClass = "has-value";

	const blur = () => {
		const hasValue = value.length
		const removedFocusClass = renderedClassList.replace(`${focusClass} `, "")

		const newClassName = hasValue ? removedFocusClass : className
		setRenderedClassList(newClassName);
	}

	const focus = () => {
		inputElement.current.focus();
		const hasValue = /has-value/.test(renderedClassList) ? "" : hasValueClass + " "
		setRenderedClassList(`${hasValue}${focusClass} ${renderedClassList}`);
	}

	const targetValue = (e) => {
		setValue(e.target.value);
		onChange(e.target.value);
	}

	useEffect(() => {
		setValue(initValue)
		if (disabled || initValue !== "") {
			setRenderedClassList(`${className} has-value`)
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initValue])

	const inputElement = useRef(null);
	useEffect(() => {
		if (autofocus && inputElement.current) {
			inputElement.current.focus();
		}
	}, [autofocus]);

	return (<>
		<div className={`input-block ${className || ""}`}>
			<input
				disabled={disabled}
				type={type}
				ref={inputElement}
				id={id}
				required
				name={name}
				data-cy={dataCy}
				autoComplete={autocomplete}
				value={value}
				onChange={targetValue}
				className={renderedClassList}
				onFocus={focus}
				onBlur={blur}
				aria-labelledby={id+"-label"}
			/>
			<span id={id+"-label"} className={`placeholder${props.rounded ? " border_radius_6px" : ""}`}>{placeholder}</span>
		</div>
	</>);
};

export default Input;

